import { useEffect, useState } from "react";
import styled from "styled-components";
import { FiArrowUp } from "react-icons/fi"; // Feather icon for up arro

const ScrollToTopButton = () => {

    const [scroll, setScroll] = useState(0);
    const [visible, setVisible] = useState(false);

    const radius = 28;
    const stroke = 4;
    const normalizedRadius = radius - stroke / 2;
    const circumference = 2 * Math.PI * normalizedRadius;

    const strokeDashoffset = circumference - (scroll / 100) * circumference;


    const handleScroll = () => {
        const scrollTop = window.scrollY;
        const docHeight = document.documentElement.scrollHeight - window.innerHeight;
        const scrollPercent = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
        setScroll(scrollPercent);
        setVisible(scrollTop > 100); // Show after scrolling 100px
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    useEffect(() => {
        handleScroll(); // Initial load
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return(
        <ScrollButtonWrapper onClick={scrollToTop} style={{ opacity: visible ? 1 : 0 }}>
            <ArrowButton>
                <FiArrowUp />
            </ArrowButton>
            <CircleSvg width="60" height="60">
                <circle
                stroke="#a5ff00"
                fill="transparent"
                strokeWidth={stroke}
                strokeLinecap="round"
                strokeDasharray={circumference}
                strokeDashoffset={strokeDashoffset}
                r={normalizedRadius}
                cx="30"
                cy="30"
                />
            </CircleSvg>
        </ScrollButtonWrapper>
    )
}

const ScrollButtonWrapper = styled.div`
  position: fixed;
  bottom: 40px;
  right: 40px;
  width: 60px;
  height: 60px;
  z-index: 999;
  cursor: pointer;
  transition: opacity 0.4s ease-in-out;
  opacity: 0;
  pointer-events: auto;
`;

const CircleSvg = styled.svg`
  position: absolute;
  top: 0;
  left: 0;
  transform: rotate(-90deg);
  pointer-events: none;
`;

const ArrowButton = styled.div`
  width: 100%;
  height: 100%;
  background-color: #222;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #a5ff00;
  font-size: 22px;
  z-index: 2;
  position: relative;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);
`;

export default ScrollToTopButton;